import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { accountQuery, cmsPagesQuery, hostBaseUrl } from '@/api';
import { promotionsFromPages, type Promotion } from '@/domain';
import { useTranslations } from '@/i18n/TranslationsProvider';

export function usePromotions(): {
  promotions: Promotion[];
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
} {
  const { data: account } = useQuery(accountQuery());
  const { selectedLanguage } = useTranslations();
  const accountGuid = account?.Guid ?? '';

  const { data, isLoading, isError, error } = useQuery({
    ...cmsPagesQuery(accountGuid, selectedLanguage),
    enabled: Boolean(accountGuid && selectedLanguage),
  });

  const promotions = useMemo(() => {
    if (!accountGuid || !data?.Data) return [];
    return promotionsFromPages(data.Data, hostBaseUrl('users'), accountGuid);
  }, [accountGuid, data]);

  return {
    promotions,
    isLoading,
    isError,
    error: error instanceof Error ? error : error ? new Error(String(error)) : null,
  };
}
